/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
-----------------------------------------------------------------------------*/

<template>
  <div :class="isSmall ? 'sm-rec-select flex-container' : 'flex-container'">
    <div class="sr-only">
      <span>Use the Selected recording select box to pick a recording.</span>
      <label for="screenReaderSelectRecording">
        Selected Recording:
      </label>
      <select
        id="screenReaderSelectRecording"
        v-model="screenRecording"
        @change="screenReader"
      >
        <option
          v-for="option in options"
          :value="option"
        >
          {{ option.title }}, {{ option.createdDate | date }}
        </option>
      </select>
    </div>
    <div
      class="recording-select-container"
      aria-hidden="true"
    >
      <div class="recording-select">
        <vue-select
          :options="options"
          :value="recording ? recording.title : null"
          :searchable="!isSmallViewport"
          label="title"
          @input="loadRecording"
        >
          <template
            slot="option"
            slot-scope="option"
          >
            <div>
              <div style="display: inline-block; width: 20px; vertical-align: top; padding-top: 4px; margin-left: -10px;">
                <svg
                  version="1.1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 313.7 423"
                  style="enable-background:new 0 0 313.7 423;"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      class="mic-icon-path"
                      d="M313.7,210.3h-31.3c-1.9,31.2-15.4,59.2-36.6,80.1c-22.8,22.1-54.3,35.8-88.9,35.8c-34.8,0-66.2-13.7-89-35.8
                    c-21.3-20.9-34.8-48.9-36.3-80.1H0c3.2,70.8,55.6,129.3,124.8,143.3v36.1H52.5V423h208.5v-33.3h-72.1v-36.1
                    C258.1,339.6,310.6,281.1,313.7,210.3 M156.9,288.9c44,0,79.9-34.9,79.9-77.9v-13.7h-44.5v-37.5h44.5V129h-44.5V91.6h44.5V77.9
                    c0-43.1-35.9-77.9-79.9-77.9c-44.2,0-80,34.8-80,77.9v13.7h43.7V129H76.9v30.7h43.7v37.5H76.9v13.7
                    C76.9,253.9,112.7,288.9,156.9,288.9"
                    />
                  </g>
                </svg>
              </div>
              <div style="display: inline-block; padding-left: 4px;">
                <strong>
                  <span>{{ option.title }}</span>
                  &nbsp;
                  <svg
                    v-if="option.failed"
                    class="icon-alert-triangle"
                    style="width: 12px; height: 12px;"
                  >
                    <use xlink:href="/static/svg-symbols.svg#icon-alert-triangle" />
                  </svg>
                  <svg
                    v-if="option.processing"
                    class="icon-refresh rotate"
                    style="width: 12px; height: 12px;"
                  >
                    <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
                  </svg>
                  <svg
                    v-if="option.uploading"
                    class="icon-arrow-up"
                    style="width: 12px; height: 12px;"
                  >
                    <use xlink:href="/static/svg-symbols.svg#icon-arrow-up" />
                  </svg>
                </strong>
                <br>
                <small class="recording-filename">
                  {{ option.createdDate | date }}{{
                    (option.fileName && typeof option.fileName === 'string' &&
                      !option.fileName.match(/^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}\.wav$/i) &&
                      !option.fileName.match(/^[0-9A-F]{32}\.wav$/i)
                    ) ? ' - ' + option.fileName : '' }}
                </small>
              </div>
            </div>
          </template>
        </vue-select>
      </div>
    </div>
  </div>
</template>

<style lang="less">
  .v-select .open-indicator:before,
  ul.dropdown-menu {
    border-color: #333 !important;
    border-radius: 0px !important;
  }
  .v-select .dropdown-toggle {
    border-color: #333 !important;
    border-radius: 0px !important;
  }
  .v-select.open .dropdown-toggle {
    border-bottom-color: #fff !important;
  }
  .v-select input[type=search] {
    width: 0px !important;
  }
  .open input[type=search] {
    width: auto !important;
  }
  .v-select.dropdown .highlight a,
  .v-select.dropdown li:hover a {
    color: #333 !important;
  }

  .sm-rec-select {
    div.dropdown-toggle {
      span.selected-tag {
        font-size: 14px !important;
      }
    }
  }
  div.dropdown-toggle {
    span.selected-tag {
      font-size: 14px;
      font-weight: 400;
    }
    button.clear {
      span {
        display:none !important;
      }
      display:none !important;
    }
  }
  .flex-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: stretch;
  }
  .recording-select-container {
    flex-grow: 8;
  }
  @media (max-width: 991px) {
    .flex-container {
      display: block !important;
    }
  }
</style>

<style lang="less" scoped>
  /* SVG Microphone */
  .mic-icon-path {
    fill: #333;
  }
  .recording-select-label {
    text-align: left;
    padding: 0 0 0 17px;
    display: block;
  }
  .recording-select, .v-select {
    margin: 0 0 12px 0;
  }
</style>

<script>
import VueSelect from 'vue-select';
import util from '../utils/util';

export default {
  components: {VueSelect: VueSelect},
  props: ['recordings', 'recording', 'isSmall'],
  data() {
    return {
      screenRecording: null,
    };
  },
  computed: {
    isSmallViewport: {
      cache: false,
      get: util.isSmallViewport
    },
    options: {
      'cache': false,
      get() {
        return this.recordings;
      }
    }
  },
  updated() {
    if (this.recording) {
      this.screenRecording = this.recording;
    }
  },
  created() {
    if (this.recording) {
      this.screenRecording = this.recording;
    }
    window.setTimeout(() => {
      const tag = document.querySelector('div.dropdown-toggle span.selected-tag');
      if (tag) {
        tag.addEventListener('click', () => {
          document.querySelector('input.form-control').focus();
        });
      }
    }, 200);
  },
  methods: {
    loadRecording(option) {
      return this.$emit('loadRecording', option);
    },
    screenReader() {
      this.loadRecording(this.screenRecording);
    }
  }
};
</script>
